import { createContext } from 'react';
import { Displays, DisplaysValues } from '../type';

export const DisplayModeContext = createContext<{
  displayMode: DisplaysValues;
}>({ displayMode: Displays.LANDSCAPE });
